<template>
  <!--
  <div class="app flex-row align-items-center"
      :style="{ backgroundImage: 'url(img/background.jpg)' }">
  -->      
  <div class="app app-body flex-row align-items-center">
    <div id="spinner" class="justify-content-center align-items-center"
        :style="{ 
          height: spinnerHeight + 'px', 
          width: spinnerWidth + 'px' }"
        v-if="procesando">
      <b-spinner id="spinner-spin" label="Loading..."></b-spinner>
    </div>

    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6">
          <b-card-group>
            <b-card no-body class="p-4 login-card">
              <b-card-body>
                <b-form>
                  <h1>Iniciar Sesión</h1>
                  <p class="text-muted">Ingrese sus credenciales de acceso</p>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text>
                        <i class="icon-user"></i>
                      </b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input 
                      type="text" 
                      class="form-control" 
                      v-model="credenciales.email" 
                      placeholder="Email" 
                      autocomplete="email" />
                  </b-input-group>
                  <b-input-group class="mb-4">
                    <b-input-group-prepend>
                      <b-input-group-text>
                        <i class="icon-lock"></i>
                      </b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input
                      :type="showPass ? 'text' : 'password'"
                      class="form-control" 
                      v-model="credenciales.password" 
                      placeholder="Contraseña" 
                      autocomplete="current-password"
                      @keyup.enter.native="login"/>

                      <!-- <b-button class="show-hide-pass" @click="showHidePass">
                        <i :key="showPassKey" 
                          :class="{ 'fa fa-eye': !showPass, 'fa fa-eye-slash': showPass }"></i>
                      </b-button> -->

                      <span class="show-hide-pass" @click="showHidePass">
                        <i :key="showPassKey" 
                          :class="{ 'fa fa-eye': showPass, 'fa fa-eye-slash': !showPass }"></i>
                      </span>

                  </b-input-group>
                  <b-row>
                    <b-col cols="6">
                      <b-button variant="primary" 
                        class="px-4"
                        @click.prevent="login">Iniciar Sesión</b-button>
                    </b-col>
                    <b-col cols="6" class="text-right">
                      <b-button variant="link" class="px-0"
                        @click.prevent="forgot">Olvidé mi contraseña</b-button>                      
                      <!-- <b-button variant="link" class="px-0">Olvidé mi contraseña</b-button> -->
                    </b-col>
                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>
          </b-card-group>

          <b-alert
            class="alert"
            :show="dismissCountDown"
            dismissible
            fade
            :variant="alertVariant"
            @dismissed="dismissCountDown= 0"
            @dismiss-count-down="countDownChanged">
            <p>{{ alertMsj }}</p>
          </b-alert>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { msjAlert } from '../../mixins/msjAlert';

export default {
  name: 'Login',
  mixins: [ 
    msjAlert
  ],
  data () {
    return {
      credenciales: {
        email: '',
        password: '',
      },

      showPass: false,
      showPassKey: 0
    }
  },
  computed: {
    procesando: {
      get: function () {
        return this.$store.getters['spinnerProcesando/procesando'];
      },
      set: function (newValue) {
      }
    },
    spinnerHeight: {
      get: function () {
        return this.$store.getters['spinnerProcesando/height'];
      },
      set: function (newValue) {
      }
    },
    spinnerWidth: {
      get: function () {
        return this.$store.getters['spinnerProcesando/width'];
      },
      set: function (newValue) {
      }
    },
  },
  created() {
  },
  methods: {
    login (){
      this.showSpinner();
      this.$store.dispatch('user/login', this.credenciales)
        .then(() => this.$router.push({ name: 'Home' }))
        // .then(() => this.$router.push({ name: 'LoginCliente' }))
        .catch(error => this.showAlertError(error))
        .finally(() => this.hideSpinner());
    },
    forgot (){
      this.$router.push({ name: 'ForgotPassword' });
    },
    showHidePass() {
      this.showPass = !this.showPass;
      this.showPassKey++;
    }
  }
}
</script>

<style>
</style>